<template>
	<div>
		<el-container class="navpage">
			<el-aside class="aside-primary animated" :class="asideShow ? 'fadeInLeftBig width240' : 'fadeOutLeftBig width0'">
				<el-divider content-position="center">按模型进行筛选</el-divider>
				<el-menu
					:default-active="''"
					class="el-menu-demo el-menu-parent"
					@open="handleOpen"
					@close="handleClose"
					text-color="#000"
					active-text-color="#ff3a68"
					unique-opened
					menu-trigger="click"
					@select="chooseModelPath"
				>
					<el-menu-item :index="''"><strong>查看全部</strong></el-menu-item>
					<template v-if="modelNavs.length">
						<el-menu-item v-for="(item, index) in modelNavs" :key="index" :index="'mNavs' + item['mid']">
							<strong>{{ item.modelname }}</strong>
						</el-menu-item>
					</template>
				</el-menu>
				<el-divider content-position="center">按分类进行筛选</el-divider>
				<el-menu
					:default-active="tNavDefault"
					class="el-menu-demo el-menu-parent"
					text-color="#000"
					active-text-color="#ff3a68"
					unique-opened
					menu-trigger="click"
					@select="chooseTypePath"
				>
					<el-menu-item :index="''"><strong>查看全部</strong></el-menu-item>
				</el-menu>
				<el-tree
					node-key="tid"
					:data="typeNavs"
					:highlight-current="true"
					:props="{
						children: 'children',
						label: 'typename'
					}"
					@node-click="typechange"
				></el-tree>
			</el-aside>
			<el-main style="padding: 0 10px;">
				<el-button type="default" size="mini" @click="asideShow = !asideShow">{{ asideShow ? '隐藏' : '显示' }}侧边栏</el-button>
				<el-dropdown trigger="click" @command="addCommand">
					<el-button type="primary" icon="el-icon-edit" size="mini">
						添加内容
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<template v-if="modelNavs.length">
							<div v-for="(item, index) in modelNavs" :key="index">
								<el-dropdown-item v-if="!item.isbase" :command="item.mid">{{ item.modelname }}</el-dropdown-item>
							</div>
						</template>
					</el-dropdown-menu>
				</el-dropdown>
				<el-dropdown trigger="click">
					<el-button type="primary" icon="el-icon-edit" size="mini">
						筛选
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(items, index) in filtrateList" :key="index">
							<el-dropdown trigger="hover" placement="right-start" @command="seleCommand">
								<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										icon="el-icon-caret-right"
										v-for="(item, key) in items.seconds"
										:key="key"
										:command="{ indexa: index, indexb: key, param: items.paramValue, paramval: item.val }"
										:class="item.checked ? 'color-blue' : ''"
									>
										{{ item.label }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-button-group>
					<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
					<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
				</el-button-group>
				<el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteSec">删除</el-button>
				<el-button type="warning" size="mini" icon="el-icon-refresh" @click="getDocumentList">刷新</el-button>
				<el-dropdown trigger="click">
					<el-button type="success" icon="el-icon-setting" size="mini">
						设置
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(items, index) in setList" :key="index">
							<el-dropdown trigger="hover" placement="right-start" @command="setCommand">
								<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										icon="el-icon-caret-right"
										v-for="(item, index) in items.seconds"
										:key="index"
										:command="{ setParam: items.paramValue, setParamVal: item.val }"
									>
										{{ item.label }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<div @keyup.enter="getDocumentList" style="margin: 15px 0;">
					<el-row>
						<el-col :span="8" :offset="16">
							<el-input v-model="search" placeholder="请输入搜索条件"><el-button slot="append" icon="el-icon-search" @click="getDocumentList"></el-button></el-input>
						</el-col>
					</el-row>
				</div>

				<div>
					<el-tabs :value="String(currentIndex)" type="card" closable @tab-remove="delpath" @tab-click="pathChange">
						<el-tab-pane v-for="(item, index) in historyPaths" :key="index" :label="item.title" :name="String(index)"></el-tab-pane>
					</el-tabs>
				</div>

				<el-table
					:data="docList"
					style="width: 100%;margin-bottom: 20px;"
					row-key="did"
					:stripe="true"
					:default-sort="{ prop: 'pid', order: 'descending' }"
					@sort-change="sortChange"
					@selection-change="selectChange"
					tooltip-effect="dark"
					ref="multipleTable"
				>
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="did" label="序号" width="80" sortable></el-table-column>
					<el-table-column prop="pid" label="排序" width="80" sortable></el-table-column>
					<el-table-column prop="mid" label="所属模型">
						<template slot-scope="scope">
							{{ mlist[scope.row.mid] ? mlist[scope.row.mid].modelname : '' }}
						</template>
					</el-table-column>
					<el-table-column prop="tid" label="分类名称">
						<template slot-scope="scope">
							{{ tlist[scope.row.tid].typename }}
						</template>
					</el-table-column>
					<el-table-column prop="title" label="内容标题" show-overflow-tooltip min-width="300">
						<template slot-scope="scope">
							<el-link :href="scope.row.link" target="_blank">{{ scope.row.title }}</el-link>
						</template>
					</el-table-column>
					<el-table-column prop="addtime" label="发布时间" sortable show-overflow-tooltip min-width="110"></el-table-column>
					<el-table-column prop="click" label="访问量" align="center" sortable show-overflow-tooltip min-width="100"></el-table-column>
					<!-- <el-table-column prop="ishtml" label="生成类型">
						<template slot-scope="scope">
							{{ ['默认系统', '静态页面', '强制动态'][scope.row.ishtml] }}
						</template>
					</el-table-column> -->
					<el-table-column prop="isclass" label="信息状态" align="center">
						<template slot-scope="scope">
							<i :class="scope.row.isclass ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column prop="pic" label="代表图片" align="center">
						<template slot-scope="scope">
							<i :class="scope.row.pic ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column prop="istop" label="置顶" align="center">
						<template slot-scope="scope">
							<i :class="scope.row.istop ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="addtime" label="状态" show-overflow-tooltip></el-table-column> -->
					<el-table-column label="操作" width="150">
						<template slot-scope="scope">
							<el-button type="warning" size="mini" @click="changeDocument(scope.row)">修改</el-button>
							<el-button type="success" size="mini" @click="copyDocument(scope.row)">复制</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="thispage"
						:page-sizes="pageSizes"
						:page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</el-main>
		</el-container>
	</div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default {
	name: 'doclist',
	data() {
		return {
			asideShow: true,
			modelNavs: [], //侧边栏操作菜单,模型筛选
			typeNavs: [], //分类筛选
			tNavDefault: '',
			tNavTabs: ['tnavs', 'tsnavs', 'ttnavs'],
			thispage: 1,
			total: 0,
			pagesize: 10, //每页显示条数
			pageSizes: [10, 15, 20, 30], //每页显示个数选择器
			sort_param: 'pid', //排序字段
			sort_type: 'desc', //排序方式ascending = asc;descending = desc,'' = asc;
			docList: [],
			mid: '',
			tid: '',
			selectedDocIds: [],
			mlist: [],
			tlist: [],
			filtrateList: [
				{
					label: '个性化模板',
					paramValue: 'istemplates',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '留言功能',
					paramValue: 'ismess',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '跳转状态',
					paramValue: 'islink',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '生成类型',
					paramValue: 'ishtml',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 0,
							label: '默认系统'
						},
						{
							val: 1,
							label: '静态页面'
						},
						{
							val: 2,
							label: '强制动态'
						}
					]
				},
				{
					label: '启用状态',
					paramValue: 'isclass',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '加入轮播',
					paramValue: 'isbanner',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '置顶状态',
					paramValue: 'istop',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				}
			],
			setList: [
				{
					label: '留言功能',
					paramValue: 'ismess',
					seconds: [
						// {
						// 	val: '',
						// 	label: '全部',
						// 	checked:true
						// },
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '启用状态',
					paramValue: 'isclass',
					seconds: [
						// {
						// 	val: '',
						// 	label: '全部',
						// 	checked:true
						// },
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '加入轮播',
					paramValue: 'isbanner',
					seconds: [
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '置顶',
					paramValue: 'istop',
					seconds: [
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				}
			],
			docIds: [],
			selectParams: [],
			setParam: '',
			setParamVal: '',
			search: ''
		};
	},
	mounted() {
		this.getAsideNavs('opened');
		document.addEventListener('visibilitychange', this.handleVisiable);
	},
	destroyed() {
		document.removeEventListener('visibilitychange', this.handleVisiable);
	},
	computed: {
		...mapState({
			historyPaths: state => state.path.historyPaths,
			currentIndex: state => state.path.currentIndex
		})
	},
	activated() {
		// console.log('doclist-actived');
		// this.getAsideNavs('opened');
	},
	methods: {
		...mapMutations({
			delHistoryPath: 'path/delHistoryPath',
			setCurrentIndex: 'path/setCurrentIndex'
		}),
		handleVisiable(e) {
			switch (e.target.visibilityState) {
				case 'prerender':
					console.log('网页预渲染，内容不可见');
					break;
				case 'hidden':
					console.log('警告！你已经离开当前页面');
					break;
				case 'visible':
					console.log('页面show');
					this.getAsideNavs('opened_back');
					break;
			}
		},
		delpath(e) {
			this.delHistoryPath(e);
		},
		pathChange(e) {
			this.setCurrentIndex(e.name);
		},
		changeDocument(scope) {
			// this.$router.push({ path: '/document/addDocument', query: { mid: scope.mid, mlabel: this.mlist[scope.mid].modelname, did: scope.did } });
			
			let routeUrl = this.$router.resolve({
				path: '/document/addDocument',
				query: { mid: scope.mid, mlabel: this.mlist[scope.mid].modelname, did: scope.did }
			});
			window.open(routeUrl.href, '_blank');
		},
		copyDocument(scope){
			this.$confirm('是否复制当前选中的数据?')
			.then(_=>{
				this.$axios({
					url: this.HOST + '/admin.document/copyDocument',
					method: 'post',
					data: {
						adminid: JSON.parse(this.$store.state.user.userInfo).id,
						token: JSON.parse(this.$store.state.user.userInfo).token,
						did:scope.did
					}
				})
					.then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							if (res.data.admin_err == 'admininfo_error') {
								this.$message.error(res.data.msg);
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						} else {
							this.$message.success(res.data.msg);
							this.getDocumentList();
						}
					})
					.catch(err => {});
			})
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath);
		},
		getAsideNavs(active) {
			this.$axios({
				url: this.HOST + '/admin.document/asideNavsList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						if(active != 'opened_back'){
							this.modelNavs = res.data.modelNavs;
							console.log(JSON.stringify(this.setList));
							this.typeNavs = res.data.typeNavs;
							this.mlist = res.data.mlist;
							this.tlist = res.data.tlist;
						}
						// if (active == 'opened') {
						this.getDocumentList();
						// }
					}
				})
				.catch(err => {});
		},
		chooseModelPath(index, path) {
			console.log(index, path);
			this.mid = index.replace('mNavs', '');
			this.tNavDefault = this.tid = '';
			this.getDocumentList();
		},
		typechange(data) {
			console.log(data);
			this.tid = data.tid;
			this.getDocumentList();
		},
		chooseTypePath(index, path) {
			let i = path.length - 1;
			console.log(this.typeNavs);
			this.tid = index.replace(this.tNavTabs[i], '');
			this.getDocumentList();
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending' ? 'desc' : 'asc';
			this.getDocumentList();
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getDocumentList();
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getDocumentList();
		},
		getDocumentList() {
			this.selectedDocIds = []; //初始化选中值
			console.log(this.selectParams);
			let separ = [];
			for (let i in this.selectParams) {
				console.log(i, this.selectParams[i]);
				separ.push({ param: i, paramVal: this.selectParams[i] });
			}
			this.$axios({
				url: this.HOST + '/admin.document/getDocumentList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					thispage: this.thispage,
					pagesize: this.pagesize,
					sort_param: this.sort_param,
					sort_type: this.sort_type,
					mid: this.mid,
					tid: this.tid,
					selectParams: separ,
					search: this.search
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.docList = res.data.data;
						this.total = res.data.total;
						this.docIds = [];
						this.docList.map(doc => {
							this.docIds.push(doc.did);
						});
						console.log('docids:', this.docIds);
					}
				})
				.catch(err => {});
		},
		selectChange(selection) {
			console.log(selection);
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].did);
			}
			this.selectedDocIds = arr;
			console.log(this.selectedDocIds);
		},
		addCommand(command) {
			console.log('add:', command);
			// this.$router.push({ path: '/document/addDocument', query: { mid: command, mlabel: this.mlist[command].modelname } });
			
			let routeUrl = this.$router.resolve({
				path: '/document/addDocument',
				query: { mid: command, mlabel: this.mlist[command].modelname } 
			});
			window.open(routeUrl.href, '_blank');
			
		},
		seleCommand(command) {
			console.log('sele:', command);
			this.selectParams[command.param] = command.paramval;
			this.filtrateList[command.indexa].seconds.map(item => {
				this.$set(item, 'checked', false);
			});
			this.filtrateList[command.indexa].seconds[command.indexb].checked = true;
			console.log(this.selectParams);
			this.getDocumentList();
		},
		setCommand(command) {
			console.log('set:', command);
			this.setParam = command.setParam;
			this.setParamVal = command.setParamVal;
			this.setDocumentParam();
		},
		setDocumentParam() {
			if (!this.selectedDocIds.length) {
				this.$message.error('尚未选中任何内容');
				return false;
			}
			this.$axios({
				url: this.HOST + '/admin.document/setDocument',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					docIds: this.selectedDocIds,
					setParam: this.setParam,
					setParamVal: this.setParamVal
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.docList.map(item => {
							if (this.selectedDocIds.indexOf(item.did) !== -1) {
								item[this.setParam] = this.setParamVal;
							}
						});
						this.$message.success(res.data.msg);
						// this.selectedDocIds = []//选中值初始化
					}
				})
				.catch(err => {});
		},
		// 全选
		selectAll() {
			this.docList.map(item => {
				this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
			});
			this.selectedDocIds = this.docIds;
		},
		// 反选
		selectDiff() {
			let diff = [];
			this.docList.map(item => {
				if (this.selectedDocIds.indexOf(item.did) != -1) {
					this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
				} else {
					diff.push(item.did);
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
			this.selectedDocIds = diff;
			console.log(this.selectedDocIds);
		},
		deleteSec() {
			if (!this.selectedDocIds.length) {
				this.$message.error('尚未选中任何内容');
			} else {
				this.$confirm('确定要删除选中内容？此操作不可恢复请谨慎操作！')
				.then(_=>{
					this.$axios({
						url: this.HOST + '/admin.document/delDocument',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							docIds: this.selectedDocIds
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getDocumentList();
							}
						})
						.catch(err => {});
				})
			}
		}
	}
};
</script>
<style lang="scss">
.el-main {
	padding: 0;
	.navpage {
		min-height: calc(100vh - 161px);
		.aside-primary {
			width: 240px;
			height: 100%;
			background-color: #ecf5ff;
			// height: 100%;
			padding: 20px;
			.el-divider__text {
				background-color: #ecf5ff;
				padding: 0 2px;
				font-size: 13px;
			}
			.el-menu-parent {
				background-color: transparent;
				.el-submenu {
					margin-bottom: 10px;
					background-color: #fff;
				}
				.el-menu-item {
					height: 45px;
					line-height: 45px;
					margin-bottom: 10px;
					background-color: #fff;
					min-width: 180px;
				}
			}
		}
		.width240 {
			width: 240px !important;
			transition: 0.8s;
		}
		.width0 {
			width: 0 !important;
		}
		.color-green {
			color: green;
		}
		.color-red {
			color: #ff2f4b;
		}
		.el-dropdown {
			margin: 0 10px;
		}
		.el-button-group + .el-button {
			margin-left: 10px;
		}
		.el-dropdown + .el-dropdown {
			margin-left: 0;
		}
		.el-tree {
			background-color: transparent;
			> .el-tree-node {
				margin-bottom: 10px;
			}
			.el-tree-node {
				.el-tree-node__content {
					min-height: 45px;
					line-height: 45px;
					background-color: #fff;
				}
			}
		}
	}
}
</style>
